 <template>
    <el-select
        @change="SelectChange"
        v-model="selectValue"
        size="mini"
        :style="{ width: width, margin: margin }"
        :disabled="disabled"
        placeholder="请选择角色"
        clearable
        multiple>
        <el-option v-for="(item, idx) in select" :key="idx" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>
<script>
export default {
    props: {
        value: {
            type: [String, Array],
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '100%'
        },
        margin: {
            type: String,
            default: '0px'
        },
    },
    watch: {
        value () {
            this.selectValue = this.value
        }
    },
    data () {
        return {
            select: [],
            selectValue: null,
        }
    },
    mounted () {
        this.$http.post('/9api/users-role/search-all').then(rps => {
            this.select = rps.data
        })
    },
    methods: {
        SelectChange(data) {
            this.$emit('input', data)
        }
    }
}
</script>